import ModelPrototype, { Method } from "@models/ModelPrototype";

export default class Workshop extends ModelPrototype {
  public async get(): Promise<any> {
    try {
      return this.withUrl(`main/workshop`).setMethod(Method.GET).request();
    } catch (Exception) {
      throw Exception;
    }
  }
}
